import React from 'react';
import '../../views/ConcejoView.css';

const Bloque = ({ item }) => {
  return (
    <>
      {item != null && (
        <div className="concejo-box">
          <div>
            <span className="bloque-nombre">{item.bloque.nombreBloque}</span>
          </div>
          <div>
            <h6>Concejales</h6>
            {item != null &&
              item.concejalesList !== null &&
              item.concejalesList.length > 0 &&
              item.concejalesList.map((concejal, idx) => (
                <div key={idx}>
                  <span className="bloque-sub">{concejal.nombre}</span>
                </div>
              ))}
            <h6 className="asesores">Asesores</h6>
            {item != null &&
              item.asesoresList !== null &&
              item.asesoresList.length > 0 &&
              item.asesoresList.map((asesor, idx) => (
                <div key={idx}>
                  <span className="bloque-sub">{asesor.nombre}</span>
                </div>
              ))}
            <h6 className="asesores">Secretaria/o</h6>
            <span className="bloque-sub">{item.bloque.nombreSecetaria}</span>
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(Bloque);
